import loadReturnSelectedOrders from "@NA/Handlers/ADIReturnSelectOrderhandler";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import ADIColors from "@NA/Utils/ADIColors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button from "@insite/mobius/Button";
import Checkbox from "@insite/mobius/Checkbox";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import Icon from "@insite/mobius/Icon";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import Img from "@insite/mobius/Img";
import Link from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { LoadingOverlay } from "@insite/mobius/index";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import getColor from "@insite/mobius/utilities/getColor";
import React, { useEffect, useState } from "react";
import { FC } from "react";
import { ResolveThunks, connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomApplicationState) => {
    return {
        isAuthenticated: state.context.session.isAuthenticated,
        selectedOrderResults: state.ADIGlobalData.ADIRMASelectOrderStore.rmaSelectOrderState,
        isLoading: state.ADIGlobalData.ADIRMASelectOrderStore.isLoading,
    };
};

const mapDispatchToProps = {
    loadReturnSelectedOrders,
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface ReturnOrderStyles {
    container?: InjectableCss;
    accordianContainer?: InjectableCss;
    accordianHeader?: InjectableCss;
    title?: TypographyProps;
    dataContainer?: GridContainerProps;
    imageContainer?: GridItemProps;
    infoContainer?: GridItemProps;
    returnSelectContainer?: GridItemProps;
    checkbox?: InjectableCss;
    footerBtnWrapper?: InjectableCss;
    continueBtn?: InjectableCss;
    cancelReturn?: InjectableCss;
    disableBtn?: InjectableCss;
    checkboxWrapper?: InjectableCss;
    descriptionText?: InjectableCss;
    smallText?: InjectableCss;
    dealerLink?: InjectableCss;
    desktopProductInfo?: HiddenProps;
}

export const returnOrderStyles: ReturnOrderStyles = {
    accordianHeader: {
        css: css`
            padding: 1rem;
            border: 1px solid ${ADIColors.gray15};
            margin-bottom: 20px;
            display: flex;
            justify-content: space-between;
        `,
    },
    title: {
        css: css`
            font-weight: 700;
            font-size: 20px;
        `,
    },
    accordianContainer: {
        css: css`
            margin-bottom: 40px;
        `,
    },
    imageContainer: {
        width: [12, 12, 2, 2, 2],
        css: css`
            img {
                width: 110px;
                margin: 0 auto;
            }
        `,
    },
    infoContainer: {
        width: [12, 12, 4, 4, 4],
        css: css`
            flex-direction: column;
            span {
                display: block;
                font-size: 14px;
            }
            h6 {
                font-weight: 600;
            }
        `,
    },
    returnSelectContainer: {
        width: [12, 12, 12, 12, 12],
        css: css`
            display: flex;
            flex-direction: column;
            gap: 0.5rem;

            span {
                font-size: 14px;
            }

            .ordered {
                width: 100px;
                display: inline-block;
            }
            .status {
                display: block;
            }

            @media screen and (max-width: 768px) {
                margin-left: -15px !important;
            }
        `,
    },
    footerBtnWrapper: {
        css: css`
            margin-top: 15px !important;
            margin-bottom: 20px !important;
            padding-top: 0px !important;
            display: flex;
            gap: 15px;
            justify-content: right;
        `,
    },
    continueBtn: {
        css: css`
            cursor: pointer;
            pointer-events: default;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: ${ADIColors.lightRed2} !important;
            color: ${ADIColors.white};
            border-color: ${ADIColors.lightRed2} !important;
            :hover {
                background-color: ${ADIColors.lightRed2} !important;
                border-color: ${ADIColors.lightRed2} !important;
            }
        `,
    },
    disableBtn: {
        css: css`
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: ${ADIColors.gray3};
            color: ${ADIColors.white};
            border-color: ${ADIColors.gray3};
            pointer-events: none;

            :hover {
                background-color: ${ADIColors.gray3};
                border-color: ${ADIColors.gray3};
            }
        `,
    },
    cancelReturn: {
        css: css`
            border-radius: 4px;
            background-color: ${ADIColors.white};
            border-color: ${getColor("primary")};

            :hover {
                background-color: ${ADIColors.white};
                border-color: ${getColor("primary")};
            }
            span {
                color: ${getColor("primary")};
                font-size: inherit !important;
            }
        `,
    },
    checkbox: {
        css: css`
            text-align: center;
            justify-content: center;
            display: flex;
            span {
                border-color: ${ADIColors.black2} !important;
                box-shadow: none !important;
            }
        `,
    },
    checkboxWrapper: {
        css: css`
            align-items: center;
            justify-content: center;
        `,
    },
    descriptionText: {
        css: css`
            font-size: 12px;
            font-weight: 700;
        `,
    },
    smallText: {
        css: css`
            display: inline-block;
            margin-right: 0.9375em;
            white-space: nowrap;
        `,
    },
    dataContainer: {
        offsetCss: css`
            @media screen and (max-width: 575px) {
                flex-wrap: nowrap !important;
                align-items: flex-start !important;
            }
        `,
        css: css`
            padding: 0.5em 1em;
            min-height: 100px;
            border-bottom: solid 1px ${ADIColors.gray24};
            font-size: 12px;
        `,
    },
    dealerLink: {
        css: css`
            text-decoration: underline;
            color: ${ADIColors.lightblue4} !important;
            display: inline-block;
            margin: 0 0.3rem;
        `,
    },
    desktopProductInfo: {
        below: "md",
        css: css`
            max-width: 30%;
        `,
    },
};

const styles = returnOrderStyles;

const ProductInfo = React.memo(({ eachProduct, hasExistingReturns }: any) => {
    return (
        <GridItem {...styles.returnSelectContainer}>
            {((eachProduct.canBeReturned && eachProduct.dgInd != "Y" && eachProduct.dgInd != "L") ||
                hasExistingReturns(eachProduct)) && (
                <>
                    <div>
                        <span className="ordered">
                            {" "}
                            {translate("Ordered")}: {eachProduct.qty}{" "}
                        </span>
                        <span className="orderNumber">
                            {translate("Order #")}: {eachProduct.orderNumber}
                        </span>
                    </div>

                    <div className="status">
                        {eachProduct.returnsCompleted > 0 && (
                            <span>
                                {translate(" Already Returned: ")}
                                {eachProduct.returnsCompleted}
                            </span>
                        )}
                        {eachProduct.returnsInProgress > 0 && (
                            <span>
                                {translate(" In Progress: ")}
                                {eachProduct.returnsInProgress}
                            </span>
                        )}
                    </div>
                </>
            )}
            {!eachProduct.canBeReturned &&
                eachProduct.dgInd != "Y" &&
                eachProduct.dgInd != "L" &&
                !hasExistingReturns(eachProduct) && (
                    <div>
                        <span>{translate("Product cannot be returned")}</span>
                    </div>
                )}
            {(eachProduct.dgInd == "Y" || eachProduct.dgInd == "L") && (
                <div>
                    <Typography>
                        {translate("This item is not eligible for an online return. Please contact")}
                        <Link href="/dealerlocator" target="_blank" {...styles.dealerLink}>
                            {"  "}
                            {translate("your local branch")}
                            {"  "}
                        </Link>
                        {translate("for assistance.")}
                    </Typography>
                </div>
            )}
        </GridItem>
    );
});

export const ADIReturnSelectOrder: FC<Props> = ({
    loadReturnSelectedOrders,
    selectedOrderResults,
    isAuthenticated,
    isLoading,
}) => {
    const [productsToBeReturned, setProductsToBeReturned] = useState<string[]>([]);
    const history = useHistory();
    const [isInProgress, setIsInProgress] = useState(false);
    React.useEffect(() => {
        if (!isAuthenticated && location.pathname.includes("MyAccount")) {
            const returnUrl = location.pathname;
            window.location.href = `/MyAccount/SignIn?returnUrl=${encodeURIComponent(returnUrl)}`;
        }
    }, []);

    const handleProductToBeReturnedSelection = (product: any) => {
        const productsToBeReturnedCopy = [...productsToBeReturned];
       const productId = product.item;
    
        const productIndex = productsToBeReturnedCopy.findIndex((eachProduct: any) => (eachProduct.item === productId && eachProduct.orderNumber === product.orderNumber));

        if (productIndex !== -1) {
            productsToBeReturnedCopy.splice(productIndex, 1);
            setIsInProgress(false);
        } else {
            setIsInProgress(true);
            productsToBeReturnedCopy.push(product);
        }
        setProductsToBeReturned(productsToBeReturnedCopy);
        handleProductsToBeReturned(productsToBeReturnedCopy);
    };

    const handleProductsToBeReturned = (productsToBeReturnedCopy: any) => {
        sessionStorage.setItem("productsToBeReturned", JSON.stringify(productsToBeReturnedCopy));
        sessionStorage.setItem("reasonCodes", JSON.stringify(reasonCodes));
    };

    const isProductSelectable = (product: any) => {
        const numberProcessed = product.returnsInProgress + product.returnsCompleted;
        return numberProcessed < product.qty && product.canBeReturned && product.dgInd != "Y" && product.dgInd != "L";
    };

    const checkIfProductSelected = (product: any) => {
        const productIndex = productsToBeReturned.findIndex((eachProduct: any) => (eachProduct.item === product.item && eachProduct.orderNumber === product.orderNumber && eachProduct.invoice_no==product.invoice_no));
       
        return productIndex > -1;
    };

    useEffect(() => {
        let selectedOrdersList: any = sessionStorage.getItem("selectedOrdersList")!;
        if (!selectedOrdersList) return;

        selectedOrdersList = JSON.parse(selectedOrdersList);
        let returnSelectOrderIDs = selectedOrdersList?.map((eachOrder: any) => eachOrder.webOrderNumber);

        if (returnSelectOrderIDs?.length) {
            loadReturnSelectedOrders({
                orders: [...returnSelectOrderIDs],
            });
        }
    }, []);

    const hasExistingReturns = (product: any) => {
        return product.returnsCompleted + product.returnsInProgress > 0;
    };

    const cancelReturnHandler = () => {
        sessionStorage.removeItem("productsToBeReturned");
        history.push("/MyAccount/Returns/SelectOrders");
    };

    const continueHandler = () => {
        const productsSelectedForReturn = sessionStorage.getItem("productsToBeReturned")!;
        history.push("/MyAccount/returns/SelectReasons");
    };

    const orders = selectedOrderResults?.orders || [];
    const reasonCodes = selectedOrderResults?.reasonCodes || [];

    return (
        <>
        { isAuthenticated && (
            <LoadingOverlay loading={isLoading}>
                <StyledWrapper {...styles.container}>
                    {orders.map((eachOrder: any) => {
                        return (
                            <StyledWrapper {...styles.accordianContainer}>
                                <StyledWrapper {...styles.accordianHeader}>
                                    <StyledWrapper>
                                        <Typography {...styles.title} as={"h3"}>
                                            {translate("Select Products to Return from Order")}
                                            {` #${eachOrder.orderNumber}`}
                                        </Typography>
                                    </StyledWrapper>
                                    <Hidden below="md">
                                        <span>-</span>
                                    </Hidden>
                                </StyledWrapper>
                                <>
                                    {eachOrder.products.map((eachProduct: any,index:number) => {
                                        if (eachProduct?.productDto) {
                                            const {
                                                productDto: {
                                                    smallImagePath,
                                                    altText,
                                                    shortDescription,
                                                    properties,
                                                    erpNumber,
                                                    modelNumber,
                                                    manufacturerItem,
                                                    customerName,
                                                },
                                                canBeReturned,
                                            } = eachProduct;

                                            return (
                                                <GridContainer {...styles.dataContainer} key={index}>
                                                    <GridItem {...styles.checkboxWrapper}>
                                                        {isProductSelectable(eachProduct) && (
                                                            <Checkbox
                                                                {...styles.checkbox}
                                                                labelPosition="right"
                                                                onChange={() => {
                                                                    handleProductToBeReturnedSelection(eachProduct);
                                                                }}
                                                                checked={checkIfProductSelected(eachProduct)}
                                                            ></Checkbox>
                                                        )}
                                                    </GridItem>
                                                    <GridItem {...styles.imageContainer}>
                                                        <Img src={smallImagePath} alt={altText} />
                                                    </GridItem>
                                                    <GridItem {...styles.infoContainer}>
                                                        <Typography {...styles.descriptionText} as={"h6"}>
                                                            {shortDescription}
                                                        </Typography>
                                                        {properties.branD_PATH && (
                                                            <Typography {...styles.smallText}>
                                                                {properties.branD_SHORTDESC}
                                                            </Typography>
                                                        )}
                                                        {erpNumber && <Typography>{erpNumber}</Typography>}
                                                        {(modelNumber || manufacturerItem) && (
                                                            <Typography>{modelNumber || manufacturerItem}</Typography>
                                                        )}
                                                        {customerName && (
                                                            <Typography>
                                                                {translate("My Part #")}
                                                                {customerName}
                                                            </Typography>
                                                        )}
                                                        <Hidden above="sm">
                                                            <ProductInfo
                                                                eachProduct={eachProduct}
                                                                hasExistingReturns={hasExistingReturns}
                                                            />
                                                        </Hidden>
                                                    </GridItem>
                                                    <Hidden {...styles.desktopProductInfo}>
                                                        <ProductInfo
                                                            eachProduct={eachProduct}
                                                            hasExistingReturns={hasExistingReturns}
                                                        />
                                                    </Hidden>
                                                </GridContainer>
                                            );
                                        }
                                    })}
                                </>
                            </StyledWrapper>
                        );
                    })}
                </StyledWrapper>
                <GridItem width={12} {...styles.footerBtnWrapper}>
                    <Button
                        {...styles.cancelReturn}
                        onClick={() => {
                            cancelReturnHandler();                            
                        }}
                        data-test-selector="orders_clearFiltersButton"
                    >
                        {translate("Cancel Return")}
                    </Button>
                    <Button
                        {...((isInProgress) ? styles.continueBtn : styles.disableBtn)}
                        onClick={() => {
                            continueHandler();
                        }}
                        data-test-selector="orders_clearFiltersButton"
                        disabled={!isInProgress}
                    >
                        {translate("Continue")} <Icon color={ADIColors.white} src={ChevronRight} size={15} />
                    </Button>
                </GridItem>
            </LoadingOverlay>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ADIReturnSelectOrder),
    definition: {
        group: "Return Request (RMA)",
        icon: "Image",
        displayName: "Return Product Select",
        fieldDefinitions: [],
    },
};

export default widgetModule;
